
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CountryResponse,
} from '../models';
import {
    CountryResponseFromJSON,
    CountryResponseToJSON,
} from '../models';

/**
 * 
 */
export class EligibilityCountriesApi extends runtime.BaseAPI {

    /**
     * Retrieve all countries used for business referrals submissions
          */
    async getCountriesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<CountryResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<CountryResponse>>({
            path: `/business-referral/api/eligibility/countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(CountryResponseFromJSON);
        return response;
    }

    /**
     * Retrieve all countries used for business referrals submissions
          */
    async getCountries(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<CountryResponse>> {
        const response = await this.getCountriesRaw(initOverrides);
        return response._data;
    }

}
